import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Ghost, ArrowRight, Home, Search } from "lucide-react";

const NotFound = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "404 — Ghost in the wire · Phantom Industries";
  }, []);

  return (
    <main className="min-h-screen bg-black text-white pt-24" data-testid="not-found-page">
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 aurora-purple opacity-70 pointer-events-none" />
        <div className="relative max-w-4xl mx-auto px-6 py-24 md:py-32 text-center">
          <div className="inline-flex items-center gap-2 chip">
            <Ghost className="h-3.5 w-3.5" /> 404 · Ghost in the wire
          </div>
          <h1
            className="mt-6 font-headline text-[7rem] md:text-[11rem] font-bold leading-none text-gradient-purple"
            data-testid="not-found-heading"
          >
            404
          </h1>
          <p className="mt-4 font-display text-2xl md:text-3xl text-white/90">
            This page went dark.
          </p>
          <p className="mt-4 text-white/60 max-w-md mx-auto">
            The address you followed doesn't exist — or it's been wiped. Either way,
            nothing here is tracking you. Let's get you back on the map.
          </p>

          <div className="mt-10 flex items-center justify-center gap-3 flex-wrap">
            <Link to="/" className="btn-primary" data-testid="not-found-home-btn">
              <Home className="h-4 w-4" /> Back to home
            </Link>
            <Link to="/shop" className="btn-ghost" data-testid="not-found-shop-btn">
              <Search className="h-4 w-4" /> Browse devices
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>

          <div className="mt-10 text-xs text-white/40">
            Looking for an order? Try the{" "}
            <Link to="/lookup" className="text-purple-300 hover:text-white underline underline-offset-4" data-testid="not-found-lookup-link">
              order lookup
            </Link>
            .
          </div>
        </div>
      </section>
    </main>
  );
};

export default NotFound;
